// extracted by mini-css-extract-plugin
export var changeIcon = "_6p-4";
export var container = "_6p-0";
export var divider = "_6p-7";
export var externalLinkIcon = "_6p-1";
export var green = "_6p-5";
export var helpCircleIcon = "_6p-3";
export var iconButton = "_6p-2";
export var red = "_6p-6";